export function isRunningInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true; // window.top can throw on cross-origin iframe
  }
}
